import * as React from 'react';
import type { SVGProps } from 'react';
import { memo } from 'react';
export const SvgResetDimension = {
  height: 16,
  width: 16,
  viewBox: '0 0 16 16',
};
export const SvgReset = memo((props: SVGProps<SVGSVGElement>) => (
  <svg width={16} height={16} viewBox="0 0 16 16" fill="none" {...props}>
    <g clipPath="url(#a)">
      <mask
        id="b"
        x="0"
        y="0"
        width="16"
        height="16"
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'alpha',
        }}
      >
        <path
          fill="currentColor"
          d="M10 20c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10"
        />
      </mask>
      <g mask="url(#b)">
        <path
          fill="currentColor"
          d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z"
        />
      </g>
      <path
        fill="#fff"
        d="M8.038 4.389V2.903L6.057 4.884l1.98 1.981V5.38A2.974 2.974 0 0 1 11.01 8.35c0 1.47-1.074 2.69-2.476 2.927v1a3.961 3.961 0 0 0-.495-7.89M5.066 8.35c0-.816.332-1.56.872-2.099l-.703-.703a3.97 3.97 0 0 0-1.16 2.803c0 2.02 1.511 3.685 3.468 3.927v-1A2.975 2.975 0 0 1 5.066 8.35"
      />
    </g>
    <defs>
      <clipPath id="a">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
